export function detectFileTypeFromExtension(
  fileName: string,
  requestedType: 'pdf' | 'word' | 'excel' | 'image' | 'txt',
): boolean {
  const extension = fileName.split('.').pop()?.toLowerCase() || '';

  switch (requestedType) {
    case 'pdf':
      return extension === 'pdf';
    case 'word':
      return ['doc', 'docx'].includes(extension);
    case 'excel':
      return ['xls', 'xlsx'].includes(extension);
    case 'image':
      return ['jpg', 'jpeg', 'png', 'gif'].includes(extension);
    default:
      return false;
  }
}
